// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import TranslatedOption from '../../../../shared/components/translated-option';

const KeyValueDropDown = ({includeKeyInDropDown, list, shouldTranslate = false, showBlankOption = true, showPlaceholder = false, ...props}) =>
    <select
        {...props}
    >
        {showBlankOption && <option value=''/>}
        {showPlaceholder &&
            <option value=''>
                <FormattedMessage id={props.placeholder}/>
            </option>
        }
        {list.map(status =>
            shouldTranslate ?
                <TranslatedOption
                    key={status.key}
                    text={status.value}
                    value={status.key}
                /> :
                    <option
                        key={status.key}
                        value={status.key}
                    >
                        {includeKeyInDropDown ?
                            `${status.key} - ${status.value}` :
                            status.value
                        }
                    </option>
            )
        }
    </select>;

KeyValueDropDown.displayName = 'KeyValueDropDown';
KeyValueDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    includeKeyInDropDown: PropTypes.bool.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    shouldTranslate: PropTypes.bool,
    showBlankOption: PropTypes.bool,
    showPlaceholder: PropTypes.bool,
    value: PropTypes.string.isRequired
};
KeyValueDropDown.defaultProps = {
    includeKeyInDropDown: false,
    showPlaceholder: false
};

export default KeyValueDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/key-value-dropdown.js